// Tarjeta del comprobante de nomina para enviar por WhatsApp (se captura como imagen JPG).
// Mismo estilo que el recibo y la cotizacion en version WhatsApp. Es un comprobante para el empleado:
// no lleva los aportes ni el costo del empleador.
const fmt = v => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(Number(v) || 0);

export default function NominaCard({ id = 'nomina-whatsapp-card', empleado = {}, mesTexto = '', qTexto = '', emitido = '', calc = {} }) {
  // En el empleado, salario_base ya incluye el auxilio de transporte: el salario base real es la resta.
  const total = Number(empleado.salario_base) || 0;
  const aux = Number(empleado.aux_transporte) || 0;
  const base = total - aux;
  const baseQ = Math.round(base / 2);
  const auxQ = Math.round(Number(calc.quincena_base) || 0) - baseQ;
  const linea = (label, valor, color) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, fontSize: 12, padding: '6px 0', borderBottom: '1px solid #eef3f7' }}>
      <span style={{ color: '#5a7a8a' }}>{label}</span>
      <strong style={{ color: color || '#08293f' }}>{valor}</strong>
    </div>
  );
  return (
    <div id={id} style={{ width: 420, maxWidth: '100%', margin: '0 auto', background: '#fff', border: '1px solid #d8e5ec', borderRadius: 10, overflow: 'hidden', fontFamily: "'Space Grotesk', sans-serif", color: '#08293f' }}>
      <div style={{ background: '#08293f', color: '#fff', padding: '18px 20px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 5, fontWeight: 800, letterSpacing: 3 }}>
          <span style={{ color: '#00b8e3', letterSpacing: -2, fontSize: 22 }}>{'//'}</span>
          <span style={{ color: '#fff', fontSize: 18 }}>AGE</span>
          <span style={{ color: 'rgba(255,255,255,0.58)', fontSize: 9, fontWeight: 400 }}>INFORMATICA</span>
        </div>
        <div style={{ marginTop: 20, display: 'grid', gap: 3 }}>
          <strong style={{ fontSize: 20 }}>Comprobante de pago</strong>
          <span style={{ color: 'rgba(255,255,255,0.68)', fontSize: 12 }}>{qTexto} · {mesTexto}</span>
        </div>
      </div>
      <div style={{ padding: '14px 18px', background: '#f8fbfd', borderBottom: '1px solid #d8e5ec', fontSize: 12, color: '#5a7a8a', lineHeight: 1.5 }}>
        <strong style={{ display: 'block', color: '#08293f', fontSize: 15, marginBottom: 2 }}>AGE Informática</strong>
        Soporte técnico, mantenimiento e infraestructura TI<br />
        info@ageinformatica.com · 313 3030874
      </div>
      <div style={{ padding: '16px 18px 10px' }}>
        <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.12em', fontWeight: 900, color: '#7f9aad', marginBottom: 5 }}>Empleado</div>
        <h2 style={{ margin: 0, fontSize: 20, color: '#08293f' }}>{empleado.nombre}</h2>
        <div style={{ marginTop: 6, color: '#5a7a8a', fontSize: 12, lineHeight: 1.45 }}>
          {empleado.cedula && <span>Cédula: {empleado.cedula}<br /></span>}
          <span>Salario base: {fmt(base)}</span>
          {aux > 0 && <span> · Aux. transporte: {fmt(aux)}</span>}
          {aux > 0 && <><br /><span>Total mensual (salario + auxilio): {fmt(total)}</span></>}
        </div>
      </div>
      <div style={{ margin: '0 18px', border: '1px solid #d8e5ec', background: '#fff', borderRadius: 7, padding: '4px 10px' }}>
        <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 900, color: '#7f9aad', padding: '8px 0 2px' }}>Devengado y deducciones · {qTexto}</div>
        {linea('Salario quincena', fmt(baseQ))}
        {aux > 0 && linea('Auxilio de transporte', fmt(auxQ))}
        {linea('Salud 4%', `− ${fmt(calc.salud_empleado)}`, '#b91c1c')}
        {linea('Pensión 4%', `− ${fmt(calc.pension_empleado)}`, '#b91c1c')}
      </div>
      <div style={{ margin: '14px 18px 0', background: '#08293f', borderRadius: 7, padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(0,184,227,0.75)', marginBottom: 3 }}>Neto a pagar</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: '#00b8e3' }}>{fmt(calc.neto_quincena)}</div>
        </div>
        <div style={{ textAlign: 'right', fontSize: 11, color: 'rgba(255,255,255,0.6)', lineHeight: 1.6 }}>
          Neto mensual<br /><strong style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13 }}>{fmt(calc.neto_mensual)}</strong>
        </div>
      </div>
      <div style={{ marginTop: 16, padding: '14px 18px', background: '#08293f', color: 'rgba(255,255,255,0.74)', fontSize: 11, lineHeight: 1.5 }}>
        <strong style={{ color: '#fff' }}>AGE Informática</strong><br />
        Comprobante generado el {emitido}.
      </div>
    </div>
  );
}
